<template>
  <div>
    <component :is="currency" :size="size" />
  </div>
</template>
<script>
export default {
  components: {
    BinanceSmartChain: () => import('@/assets/v2/icons/BinanceIcon.vue'),
    Tron: () => import('@/assets/v2/icons/TronIcon.vue'),
    Ethereum: () => import('@/assets/v2/icons/EthIcon.vue'),
    Flow: () => import('@/assets/v2/icons/FlowIcon.vue'),
    Algorand: () => import('@/assets/v2/icons/AlgorandIcon.vue'),
    Avalanche: () => import('@/assets/v2/icons/AvalancheIcon.vue'),
    Solana: () => import('@/assets/v2/icons/SolanaIcon.vue'),
    StellarLumens: () => import('@/assets/v2/icons/EthIcon.vue'),
    Hedera: () => import('@/assets/v2/icons/HederaIcon.vue')
  },
  props: {
    currency: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: () => 'h-6 w-6'
    }
  }
}
</script>
